import CatalogAdmin from "@/app/admin/catalog/CatalogAdmin";

export default function OverlaysPage() {
  return <CatalogAdmin kind="overlay" />;
}
